export abstract class Billable {
    abstract is_billable?: boolean
}
